import { environment } from '@env/environment';
import { IsBetaWindow } from '@env/version';

export default function () {
  const supported = [...(environment.supportedLanguages ?? [])];
  if (!environment.production || IsBetaWindow()) supported.push(...(environment.features.extraLanguages ?? []));
  return supported;
}
